import { render } from "./EditSubProductGroupModal.vue?vue&type=template&id=2d34b7d4"
import script from "./EditSubProductGroupModal.vue?vue&type=script&lang=js"
export * from "./EditSubProductGroupModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__